"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('observer.live', function () {
    this.loader;
    this.data = false;
    this.frameId = false; // Has to be passed
    this.init = function () {
        var _this = this;
        namespace_1.default.debug.showInfo(this.frameId + ': Starting observer.live');
        this.loader = new namespace_1.default.loader();
        this.loader.setOptions({
            url: this.getUrl(),
            success: function (tData) { return _this.sendUpdates(tData); }
        });
        this.update();
    };
    this.update = function () {
        var _this = this;
        this.loader.load();
        window.setTimeout(function () {
            _this.update();
        }, namespace_1.default.params.timers.live);
    };
    this.sendUpdates = function (tData) {
        if (!this.data) {
            this.data = tData;
        }
        else if (this.check(tData)) {
            var tEvent = jquery_1.default.Event(namespace_1.default.items[this.frameId].config.namespace + namespace_1.default.events.updater.inform);
            tEvent.content = tData;
            (0, jquery_1.default)(document).triggerHandler(tEvent);
            if (this.loader.options.jsonpCallback) {
                eval('delete ' + this.loader.options.jsonpCallback.toString());
            }
        }
    };
    this.check = function (data) {
        var tBool = false;
        this.data.forEach(function (item, value) {
            if (!data[item]) {
                tBool = true;
                return false;
            }
            if (data[item].lastUpdate != value.lastUpdate) {
                tBool = true;
                return false;
            }
        });
        return tBool;
    };
    this.getUrl = function () {
        namespace_1.default.debug.showError(this.frameId + ': live.getUrl has not been extended');
    };
});
